var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hideBars)?_c('div',{staticClass:"app-wrap"},[_c('Header'),_c('div',{staticClass:"app-container"},[_c('Sidebar'),_c('router-view')],1),_c('Footer')],1):_c('router-view')
}
var staticRenderFns = []

export { render, staticRenderFns }